import { z } from 'zod';

export const PiiActionSchema = z.enum(['VIEW_PII', 'REVEAL_PII', 'EXPORT_PII']);
export type PiiAction = z.infer<typeof PiiActionSchema>;

export const PiiEntityTypeSchema = z.enum([
  'VISITOR',
  'STAFF',
  'ORDER',
  'WRISTBAND',
  'CUSTOMER',
  'GROUP',
  'GROUP_MEMBER',
]);
export type PiiEntityType = z.infer<typeof PiiEntityTypeSchema>;

export const PiiAccessLogPayloadSchema = z.object({
  action: PiiActionSchema,
  entityType: PiiEntityTypeSchema,
  entityId: z.string(),
  fieldsAccessed: z.array(z.string()),
  ipAddress: z.string().optional(),
  userAgent: z.string().optional(),
  metadata: z.record(z.string()).optional(),
});
export type PiiAccessLogPayload = z.infer<typeof PiiAccessLogPayloadSchema>;

export const PiiLogsQuerySchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(100).optional(),
  userId: z.string().optional(),
  entityType: z.string().optional(),
  entityId: z.string().optional(),
  action: PiiActionSchema.optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  sortBy: z.literal('createdAt').optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});
export type PiiLogsQuery = z.infer<typeof PiiLogsQuerySchema>;

export const PiiAccessLogSchema = z.object({
  id: z.string(),
  userId: z.string(),
  userName: z.string(),
  action: PiiActionSchema,
  entityType: PiiEntityTypeSchema,
  entityId: z.string(),
  fieldsAccessed: z.array(z.string()),
  metadata: z.record(z.string()).optional(),
  ipAddress: z.string(),
  userAgent: z.string(),
  createdAt: z.string(),
});
export type PiiAccessLog = z.infer<typeof PiiAccessLogSchema>;

export const PiiLogsResponseSchema = z.object({
  logs: z.array(PiiAccessLogSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
  totalPages: z.number().int().nonnegative(),
});
export type PiiLogsResponse = z.infer<typeof PiiLogsResponseSchema>;
